import React from "react"
import { captions } from '../../utils/captions'
import { pxToRem } from "../../utils"
import styled from "styled-components"

const CaptionsArea = styled.div`
  margin: ${pxToRem(10)} 0;
  font-size: ${pxToRem(14)};
`

const CaptionItem = props => {
  return (
    <div>
      <strong>{props.caption}: </strong>{props.meaning}
    </div>
  )
}

const Caption = () => {

  return (
    <CaptionsArea>
      {(captions || []).map(caption => (
        <CaptionItem
          caption={caption.abbreviation}
          meaning={caption.meaning} />
      ))}
    </CaptionsArea>
  )
}

export default Caption



// WEBPACK FOOTER //
// ./src/components/Captions/Caption.js